// extracted by mini-css-extract-plugin
export var disabledStyle = "image_link-module--disabledStyle--TR3aa";
export var imageLink = "image_link-module--imageLink--FLcw7";